module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahand8-7d7d6898f6307980ee82110ca1960cce.jpg";